/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/member-ordering */
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { CategoryModel, StorePageStore } from '@boxx/store-core';
import {
  AlertController,
  ModalController,
  Platform,
} from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BoxxImageConstraints } from '@boxx/boxx-images/lib/models/BoxxImage.model';
import { BoxxUtilsService } from 'src/services/BoxxUtils.service';
import { BottomSheetType } from '@app/components/bottom-sheet/bottom-sheet.model';
import { ImageDimensionsProps, ImageUtilsService } from 'src/services/ImageUtils.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'boxx-subcategory-form',
  templateUrl: './subcategory-form.component.html',
  styleUrls: ['./subcategory-form.component.scss'],
})
export class SunbategoryFormComponent implements OnInit, OnDestroy {
  @Input() set category(category: CategoryModel) {
    this.initEmptyForm();
    if (category) {
      this.myCategory = category;
      this.patchForm(this.myCategory);
    }
  }

  @Output() boxxChange = new EventEmitter<IStoreCategoryFormEmitter>();

  isCordovaOrCapacitor = false;

  myCategory: CategoryModel;

  destroyed$ = new Subject<boolean>();

  categoryForm: FormGroup;

  totalImages = 0;

  selectedImage: { id: number; src: string };

  selectedProducts: number[] = [];

  translations: any;

  imageString: string;

  defaultImage: string = 'assets/img/image_pending.png';

  @Input() set maxLogoDimensions(payload: ImageDimensionsProps) {
    this.myMaxLogoDimensions = payload;
  }

  get maxLogoDimensions() {
    return this.myMaxLogoDimensions;
  } //{ width: 600, height: 300 };

  @Input() set maxMainDimensions(payload: ImageDimensionsProps) {
    this.myMaxMainDimensions = payload;
  }
  get maxMainDimensions() {
    return this.myMaxMainDimensions;
  } //{ width: 1749, height: 1849 };

  @Input() set maxGalleryDimensions(payload: ImageDimensionsProps) {
    this.myMaxGalleryDimensions = payload;
  }
  get maxGalleryDimensions() {
    return this.myMaxGalleryDimensions;
  } // { width: 500, height: 500 };

  @Input() set maxGalleryImages(value: number) {
    this.myMaxGalleryImages = value || this.DEFAULT_MAX_GALLERY_IMAGES;
  }

  get maxGalleryImages() {
    return this.myMaxGalleryImages;
  }

  readonly DEFAULT_MAX_GALLERY_IMAGES = 1;

  private originalValues: CategoryModel;

  isIos = false;
  isNative = false;

  private myMaxLogoDimensions: ImageDimensionsProps = {
    width: 500,
    height: 500,
  };
  private myMaxMainDimensions: ImageDimensionsProps = {
    width: 500,
    height: 500,
  };
  private myMaxGalleryDimensions: ImageDimensionsProps = {
    width: 500,
    height: 500,
  };
  private myMaxGalleryImages = this.DEFAULT_MAX_GALLERY_IMAGES;
  parentId = null;
  constructor(
    private fb: FormBuilder,
    private alertCtrl: AlertController,
    private sanitizer: DomSanitizer,
    private storePageStore: StorePageStore,
    private boxxUtils: BoxxUtilsService,
    private viewCrtl: ModalController,
    private imageService: ImageUtilsService,
    translate: TranslateService,
    platform: Platform
  ) {
    translate
      .get([
        'BUSINESS_FORMS',
        'STORE_MODULE',
        'IMAGES_MODULE',
        'ACTIONS',
        'ERRORS',
        'SUCCESS',
      ])
      .pipe(takeUntil(this.destroyed$))
      .subscribe((t: any) => (this.translations = t));

    platform.ready().then(() => {
      this.isIos = platform
        .platforms()
        .some((name) => ['ios', 'ipad', 'iphone'].includes(name));

      this.isNative = platform
        .platforms()
        .some((name) => ['cordova', 'capacitor'].includes(name));

      this.isCordovaOrCapacitor =
        platform.is('cordova') || platform.is('capacitor');
    });
  }

  ngOnInit() {
    console.log();
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  initEmptyForm() {
    this.categoryForm = this.fb.group({
      image: [''],
      name: ['', Validators.required],
      parentId: [''],
      description: [''],
      products: [[]],
      nueva: [0]
    });

    this.originalValues = this.categoryForm.value;
  }

  patchForm(category: CategoryModel) {
    this.categoryForm.patchValue({
      image: category.image,
      name: category.name,
      parentId: category.parentId,
      description: category.description
        ? this.removeHTMLInfo(category.description)
        : '',
    });

    this.originalValues = this.categoryForm.value;
  }

  removeHTMLInfo(value: string) {
    if (value) {
      return value.replace(/<\/?[^>]+>/gi, '');
    }
    return '';
  }

  onFieldChange() {
    if (this.imageString !== '') {
    }
    const values = this.categoryForm.value;

    const hasChanges = Object.keys(values).some((key) => {
      const originalValue = this.originalValues[key];
      const newValue = this.categoryForm.get(key).value;
      return newValue !== originalValue;
    });

    this.boxxChange.emit({
      hasChanges,
      data: values,
      valid: this.categoryForm.valid,
    });
  }

  openProductPicker() { }

  getFirstImage() {
    return { id: null, url: null };
  }


  async showImageOptions() {

    const buttons = [
      // {
      //   key: 'view',
      //   value: 'BUSINESS_FORMS.WEBPAGE.LOGO_ACTIONS.detail',
      //   icon: 'eye-outline',
      //   icon_type: 'name',
      //   class: 'custom'
      // },
      {
        key: 'change',
        value: 'BUSINESS_FORMS.WEBPAGE.LOGO_ACTIONS.change',
        icon: 'refresh-outline',
        icon_type: 'name',
        class: 'custom'
      }
    ];


    this.boxxUtils.openBottomSheet({
      data: buttons,
      type: BottomSheetType.options,
      initialBreakpoint: 1,
      breakpoints: [0, 1],
      canClose: true,
      title: '',
      maxHeigth: buttons.length > 1 ? 30 : 20
    }).then(async (data) => {
      if (data?.value) {
        console.log('data?.value: ', data?.value);
        // if (data?.value === 'view') {
        //   const view = await this.viewCrtl.create({
        //     component: BoxxImageDetailComponent,
        //     componentProps: {
        //       image: this.logoUrl,
        //       nameImage: this.translations.BUSINESS_FORMS.WEBPAGE.LOGO_ACTIONS.mainComponentTitle
        //     },
        //   });

        //   view.present();
        // }
        if (data?.value === 'change') {
          this.pickImagesForLogo();
        }
      }
    });

  }

  async pickImagesForLogo() {
    const imageConstraints: BoxxImageConstraints = {
      maxWidth: this.maxLogoDimensions.width,
      maxHeight: this.maxLogoDimensions.height,
      aspectRatio: this.maxLogoDimensions.aspectRatio,
    };
    this.imageService.showImagePickerSources().then(
      async (data) => {
        switch (Number(data)) {
          case 1://Picker image browser
          case 2://Picker image device library
            await this.imageService.pickerFromDevice(imageConstraints, 1).then(
              async (images) => {
                if (images && images.length > 0) {
                  this.categoryForm.patchValue({
                    image: images[0].content,
                    nueva: 1
                  });
                  this.onFieldChange();
                }
              });
            break;

          case 3://Pixabay
            await this.imageService.pickerFromPixaBay(imageConstraints, 1).then(
              async (images) => {
                if (images && images.length > 0) {
                  this.categoryForm.patchValue({
                    image: images[0].content,
                    nueva: 1
                  });
                  this.onFieldChange();
                }
              });
            break;

          case 4://Camera
            await this.imageService.pickerFromCamera(imageConstraints).then(
              async (images) => {
                if (images && images.length > 0) {
                  this.categoryForm.patchValue({
                    image: images[0].content,
                    nueva: 1
                  });
                  this.onFieldChange();
                }
              });
            break;

          default:
            break;
        }
      }
    );
  }
  // Set image constraints
  // if not set or is an empty object {}, default values will be used
  // const imageConstraints: BoxxImageConstraints = {
  //   maxWidth: this.maxLogoDimensions.width,
  //   maxHeight: this.maxLogoDimensions.height,
  // };

  // // Set options for every picker
  // // if not set or is an empty object {}, default values will be used
  // const browserPickerOptions: BoxxWebBrowserPickerOptions = {
  //   // multiple: false,
  // };
  // const pickerPluginOptions: ImagePickerOptions = { quality: 75 };
  // const cameraPluginOptions: CameraOptions = { quality: 75 };

  // const picker = await this.boxxImagePickerSourceService
  //   .setImageConstraints(imageConstraints)
  //   .setPickerOptions({
  //     ...browserPickerOptions,
  //     ...pickerPluginOptions,
  //     ...cameraPluginOptions,
  //   })
  //   .showImagePickerSources();

  // this.boxxUtils.handleLoading(true);
  // let images = await picker.onSelectedValidImages();
  // this.boxxUtils.handleLoading(false);


  // if (!images.length && typeof(images) !== 'number') {
  //   return;
  // }

  //   if(typeof(images) === 'object'){
  //     images = await this.validateAndFixImages(
  //       images.slice(0, pickerPluginOptions.maximumImagesCount)
  //     );

  //     if (images.length > 0) {      
  //       this.categoryForm.patchValue({
  //         image: images[0].content,
  //         nueva: 1
  //       });
  //       this.onFieldChange();
  //       return;
  //     }

  //     this.onFieldChange();   
  //   }
  //   else{
  //     images = await this.pickerFromPixaBay(imageConstraints, 1);
  //     if (!images) {
  //       return;
  //     }

  //     this.categoryForm.patchValue({
  //       image: images[0].content,
  //       nueva: 1
  //     });
  //     this.onFieldChange();

  //   }

  //}


  //Imágenes

  getSanitizedUrl(url: string) {
    if (typeof url !== 'string') {
      return;
    }

    if (
      !url ||
      !(
        url.startsWith('http') ||
        url.startsWith('file') ||
        url.startsWith('data')
      )
    ) {
      return 'assets/icon/images.svg';
    }

    url = url.replace('unsafe:', '');

    const response = url.startsWith('file')
      ? this.sanitizer.bypassSecurityTrustResourceUrl(
        (window as any).Ionic.WebView.convertFileSrc(url)
      )
      : this.sanitizer.bypassSecurityTrustUrl(url);

    return (response as any).changingThisBreaksApplicationSecurity || response;
  }

  showImageInContainer(data: string[]) {
    this.categoryForm.patchValue({ image: data[0] });
    this.onFieldChange();
    this.imageString = data[0];
  }

  removeImage() {
    this.confirmDeleteImage();
  }

  confirmDeleteImage() {
    this.alertCtrl
      .create({
        header: this.translations.BUSINESS_FORMS.WEBPAGE.DELETE_ALERT.header,
        message: this.translations.BUSINESS_FORMS.WEBPAGE.DELETE_ALERT.message,
        backdropDismiss: false,
        buttons: [
          {
            text: this.translations.ACTIONS.yes,
            role: 'destructive',
            handler: () => this.deleteImage(),
          },
          { text: this.translations.ACTIONS.no },
        ],
      })
      .then((a) => a.present());
  }

  async deleteImage() {
    this.categoryForm.patchValue({
      image: '',
    });
    this.onFieldChange();

    if (this.myCategory && this.myCategory.id) {
      this.storePageStore.categoriesStore.deleteImage(this.myCategory.id);
    }
  }
}
//Imágenes

export interface IStoreCategoryFormEmitter {
  hasChanges: boolean;
  data: any;
  valid: boolean;
}
